import script from "./billing-page.vue?vue&type=script&setup=true&lang=js"
export * from "./billing-page.vue?vue&type=script&setup=true&lang=js"

import "./billing-page.vue?vue&type=style&index=0&id=fc576612&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc576612"]])

export default __exports__